import { useStandardToast } from '@cks-internal/react-base';
import { PropsWithChildren } from 'react';
import { setAxiosOnError } from './lib/axios';
export const ErrorContainer = ({ children }: PropsWithChildren<Record<never, never>>) => {
  const toast = useStandardToast();

  setAxiosOnError((error) => {
    const url = error?.request?.responseURL ?? 'Unknown';
    const statusCode = error?.response?.status ?? 'Unknown';
    if (url.indexOf('auth/user') >= 0 && statusCode == 400) {
      return;
    }
    const message = error?.message ?? 'Unknown';
    toast.errorToast('API Call Failed', `The API call to ${url} failed with code ${statusCode} and message ${message}`);
  });

  return <>{children}</>;
};
